import { Component, computed, signal } from '@angular/core';

export interface DefaultState {
  loaded: boolean;
  loading: boolean;
  error: string | null;
}

export const baseState: DefaultState = {
  loaded: false,
  loading: false,
  error: null,
};

@Component({ template: '' })
export abstract class AbstractStateServiceComponent<T = DefaultState> {
  state = signal(baseState);
  readonly loading = computed(() => this.state().loading);
  readonly loaded = computed(() => this.state().loaded);
  readonly error = computed(() => this.state().error);

  reset() {
    this.resetState();
  }

  setLoading(loading: boolean) {
    this.state.set({
      ...this.state(),
      loading: loading,
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function,@typescript-eslint/no-unused-vars
  loadSessionState(key: string) {}

  protected setLoaded(loaded: boolean) {
    this.state.set({
      ...this.state(),
      loaded: loaded,
    });
  }

  protected resetState() {
    console.log('resetState');
    this.state.set({
      ...this.state(),
      loading: false,
      loaded: false,
      error: null,
    });
  }

  protected setError(error: string | null) {
    this.state.set({
      ...this.state(),
      error: error,
    });
  }

  protected setSessionStorage(key: string) {
    const sessionState = JSON.stringify(this.state());
    sessionStorage.setItem(key, sessionState);
  }
}
